export const aboutData = {
  brand: {
    title: "关于蜜桃影视",
    subtitle: "让每一部好作品都被看见",
    description: "蜜桃影视成立于2020年，是一家专注于影视内容发现与推荐的互联网平台。我们致力于为用户提供优质的影视娱乐体验，让每一位用户都能轻松找到自己喜欢的电影、电视剧、综艺节目和动漫作品。",
    mission: "我们的使命是连接优秀影视作品与广大观众，让优质内容被更多人发现和欣赏。",
    vision: "成为中国最受信赖的影视内容发现平台，推动中国影视文化的传播与发展。",
    values: [
      { title: "内容为王", description: "坚持以优质内容为核心，严格筛选每一部推荐作品，确保用户看到的都是值得花时间的好作品。" },
      { title: "用户至上", description: "深度理解用户需求，持续优化产品体验，让每一位用户都能获得个性化的影视推荐服务。" },
      { title: "技术创新", description: "持续投入技术研发，利用人工智能和大数据技术提升内容分发的精准度和效率。" },
      { title: "开放合作", description: "与各大影视制作方、发行方建立紧密合作关系，共同推动优质影视内容的传播。" },
    ],
    stats: [
      { value: "5000万+", label: "月活跃用户" },
      { value: "10万+", label: "影视资源" },
      { value: "99.2%", label: "用户满意度" },
      { value: "500+", label: "合作伙伴" },
    ],
  },
  reviews: [
    {
      id: 1,
      name: "王先生",
      rating: 5,
      content: "蜜桃影视的资源真的很全，我想看的电影基本都能找到。界面设计也很清爽，推荐算法也很准，总能发现我感兴趣的新片子。",
      date: "2026-08-10",
    },
    {
      id: 2,
      name: "李女士",
      rating: 5,
      content: "作为一个重度追剧爱好者，蜜桃影视是我每天必用的app。分类很清晰，更新也很快，新剧上线基本能第一时间看到。",
      date: "2026-08-08",
    },
    {
      id: 3,
      name: "张同学",
      rating: 5,
      content: "画质很清晰，播放流畅不卡顿，多设备同步也很方便。最喜欢的是每周的影视推荐，帮我发现了不少冷门好片。",
      date: "2026-08-05",
    },
    {
      id: 4,
      name: "刘女士",
      rating: 4,
      content: "整体体验很好，资源丰富更新快。希望能增加更多纪录片资源，个人比较喜欢看这类型的作品。推荐功能很赞！",
      date: "2026-08-01",
    },
    {
      id: 5,
      name: "陈先生",
      rating: 5,
      content: "蜜桃影视的界面设计在同类平台中算是非常优秀的，简洁大方没有广告干扰。每日推荐的影片质量也很高，已经推荐给身边很多朋友了。",
      date: "2026-07-28",
    },
    {
      id: 6,
      name: "赵女士",
      rating: 5,
      content: "从大学时期就开始用蜜桃影视了，见证了平台的不断进步。现在的个性化推荐越来越好，经常能发现合我口味的小众佳作。",
      date: "2026-07-25",
    },
  ],
  contact: {
    title: "联系我们",
    subtitle: "如有任何问题或建议，欢迎随时联系我们",
    email: "contact@mitaomovie.com",
    phone: "400-888-6666",
    address: "北京市朝阳区建国路88号SOHO现代城A座18层",
    workingHours: "周一至周五 9:00 - 18:00",
    socialMedia: [
      { name: "微博", icon: "ri-weibo-line", url: "#" },
      { name: "微信", icon: "ri-wechat-line", url: "#" },
      { name: "抖音", icon: "ri-tiktok-line", url: "#" },
      { name: "B站", icon: "ri-bilibili-line", url: "#" },
    ],
  },
};

export const faqData = [
  {
    question: "蜜桃影视是免费的吗？",
    answer: "蜜桃影视提供免费和会员两种服务模式。免费用户可以观看大量优质影视内容，会员用户则可以享受无广告、超清画质、独家内容等更多特权。",
  },
  {
    question: "如何在多个设备上使用蜜桃影视？",
    answer: "您可以在手机、平板、电脑和智能电视等多种设备上使用蜜桃影视。只需使用同一账号登录，即可在不同设备间同步观看记录和收藏内容。",
  },
  {
    question: "蜜桃影视的资源更新速度如何？",
    answer: "我们与各大影视制作方和发行方保持紧密合作，力争在影视作品上线后第一时间更新至平台。热门电影和电视剧通常在上线24小时内即可观看。",
  },
  {
    question: "如何向蜜桃影视反馈建议或问题？",
    answer: "您可以通过网站上的联系表单、官方邮箱或客服电话向我们反馈任何问题或建议。我们的客服团队会在工作时间内尽快回复您的咨询。",
  },
  {
    question: "蜜桃影视支持哪些支付方式？",
    answer: "我们支持微信支付、支付宝、银行卡等多种支付方式，方便您快速开通会员服务。",
  },
];